import { Col, Collapse } from 'antd';
import { ReactNode } from 'react';
import { useLabelPrintingContext } from '..';
import LabelPrintingToolbarCustomPanel from './CustomPanel';

interface Props {
  extraCustombar?: ReactNode;
}

export default function WrapperLabelPrintingPageCustombar(props: Props) {
  const { customOptions } = useLabelPrintingContext();

  if (!customOptions?.length && !props.extraCustombar) return null;

  return (
    <Col className="print-page-custombar">
      {!!props.extraCustombar && props.extraCustombar}

      {!!customOptions?.length && (
        <Collapse
          defaultActiveKey={['custom']}
          className="print-page-toolbar-collapse"
        >
          <Collapse.Panel header="Customização" key="custom">
            <LabelPrintingToolbarCustomPanel />
          </Collapse.Panel>
        </Collapse>
      )}
    </Col>
  );
}
